import { css } from '@emotion/react';

import Spinner from '~/common/components/utils/Spinner';
import { useAppSelector } from '~/common/stores';

/**
 * 전역 로딩 backdrop.
 *
 * - `state.layout.isLoading` 직접 구독 (`useLoading.toggle` 로 점등)
 * - **항상 mount + display 토글** — mount/unmount + redux batch 분리 비용 회피.
 *   isLoading=false 시 `display: none` 으로 paint/animation 모두 정지.
 * - **portal 미사용** — App.tsx 부모 트리(ConfigProvider/AntdApp)가
 *   stacking context 를 만들지 않아 Spinner 의 `position: fixed` + `z-index: 9000`
 *   이 viewport root 기준으로 동작. antd Modal/Drawer(1050) 위, BaseDialog(9100) 아래.
 * - 어드민 정합성 우선: 표시되는 동안 화면 전체 블로킹.
 *
 * App.tsx 최상단에 단일 mount.
 */
function GlobalLoader() {
  const isLoading = useAppSelector(state => state.layout.isLoading);

  return (
    <div css={!isLoading && styles.hidden}>
      <Spinner size={62} fullScreen />
    </div>
  );
}

const styles = {
  hidden: css`
    display: none;
  `,
};

export default GlobalLoader;
